export class Crosshair {
  private crosshairElement: HTMLDivElement;
  
  constructor() {
    // Create crosshair element
    this.crosshairElement = document.createElement('div');
    this.crosshairElement.id = 'crosshair';
    this.crosshairElement.style.position = 'absolute';
    this.crosshairElement.style.top = '50%';
    this.crosshairElement.style.left = '50%';
    this.crosshairElement.style.transform = 'translate(-50%, -50%)';
    this.crosshairElement.style.width = '16px';
    this.crosshairElement.style.height = '16px';
    this.crosshairElement.style.pointerEvents = 'none'; // Make sure it doesn't interfere with clicks
    
    // Create the crosshair shape using a plus sign
    const horizontalLine = document.createElement('div');
    horizontalLine.style.position = 'absolute';
    horizontalLine.style.top = '50%';
    horizontalLine.style.left = '0';
    horizontalLine.style.width = '100%';
    horizontalLine.style.height = '2px';
    horizontalLine.style.backgroundColor = 'white';
    horizontalLine.style.transform = 'translateY(-50%)';
    
    const verticalLine = document.createElement('div');
    verticalLine.style.position = 'absolute';
    verticalLine.style.top = '0';
    verticalLine.style.left = '50%';
    verticalLine.style.width = '2px';
    verticalLine.style.height = '100%';
    verticalLine.style.backgroundColor = 'white';
    verticalLine.style.transform = 'translateX(-50%)';
    
    // Add lines to crosshair
    this.crosshairElement.appendChild(horizontalLine);
    this.crosshairElement.appendChild(verticalLine);
    
    // Add crosshair to document body
    document.body.appendChild(this.crosshairElement);
    
    // Hide initially
    this.hide();
    
    console.log('Crosshair UI initialized');
  }
  
  public show(): void {
    this.crosshairElement.style.display = 'block';
  }
  
  public hide(): void {
    this.crosshairElement.style.display = 'none';
  }
  
  public setVisible(visible: boolean): void {
    if (visible) {
      this.show();
    } else {
      this.hide();
    }
  }
} 